export default async function placeAutocomplete({main, on, elm, state, publish}) {
	const checkoutAddress = elm.closest('checkout-address');
	const formValidation = elm.closest('form-validation');
	const countrySelect = checkoutAddress.querySelector('#country-wrapper');
	// const cityInput = checkoutAddress.querySelector('[name="shipping_address[city]"]');
	// const streetInput = checkoutAddress.querySelector('[name="shipping_address[address_1]"]');
	// const houseInput = checkoutAddress.querySelector('[name="shipping_address[address_2]"]');
	// const apartmentInput = checkoutAddress.querySelector('[name="shipping_address[company]"]');
	// const postcodeInput = checkoutAddress.querySelector('[name="shipping_address[postcode]"]');

	main(_ => {
		init();
	});

	const init = async function() {
		const { PlaceAutocompleteElement } = await google.maps.importLibrary('places');
		const gmpPlaceAutocomplete = new PlaceAutocompleteElement();
		gmpPlaceAutocomplete.classList.add('checkout-input', 'checkout-input--pn');

		elm.insertAdjacentElement('afterbegin', gmpPlaceAutocomplete);
		gmpPlaceAutocomplete.addEventListener('gmp-select', gmpSelect);
	};

	const gmpSelect = async function({ placePrediction }) {
		const place = placePrediction.toPlace();
		await place.fetchFields({fields: ['addressComponents', 'postalAddress', 'displayName', 'formattedAddress', 'location']});
		const {addressLines, locality, organization, postalCode, regionCode} = place.postalAddress;

		const country = countrySelect.querySelector(`#country [data-code="${regionCode}"]`).value;
		countrySelect.choices.setChoiceByValue(country);

		const addressParts = addressLines[0].split(' ');

		const data = {
			'shipping_address[country]': country,
			'shipping_address[city]': locality,
			'shipping_address[postcode]': postalCode,
			'shipping_address[address_1]': addressParts[0]
		};

		if (addressParts.length > 1) {
			data['shipping_address[address_2]'] = addressParts[1];
		}

		formValidation.setValues(data);
		setTimeout(() => {
			publish('checkout:save');
		}, 500);
	};
};

export const model = {};
